export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4675.ea8172b1.jpg";